import React, { Component } from "react";
import { Sidebarc } from "../src/Sidebar";
import { Appheaderc } from "./Appheader";
import { Button, Paper, Typography } from "@mui/material";
import { Box, Backdrop, CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid2";
import DownloadIcon from '@mui/icons-material/Download';
import {
  Tooltip,
  IconButton,
  TableBody,
  Table,
  Modal,
  MenuItem,
  TableContainer,
  TablePagination,
  Divider,
  TableCell,
  TableHead,
  Alert,
  TableRow,
} from "@mui/material";
import base_url from "./baseurl";
import "react-toastify/dist/ReactToastify.css";
import moment from 'moment'
import PaidIcon from '@mui/icons-material/Paid';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";



const drawerWidth = 235;
class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentList : [],
      payment_count : 0,
       page : 0,
       rowsPerPage :10,

       total_amount : 0,
    
    };
  }

  componentDidMount() {
    fetch(`${base_url.base_url}/transaction/retriveTransacionList`, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "post",
      body:JSON.stringify({
        page: this.state.page,
        rowsPerPage : this.state.rowsPerPage
      })
    })
      .then((res) => {
        return res.json();
      }) 
      .then((result) => {
        this.setState({
          paymentList : result.data,
          payment_count : result.size,
          total_amount  : result.total
        });
      });

  }








  render() {
    return (
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebarc />
          <Box
            sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
          >
            <Box sx={{ p: { xs: 1, sm: 3 }, mt: 6 }}>
              <Typography
                style={{
                  fontWeight: "bold",
                  color: "black",
                  fontSize: 16,
                  marginTop: 5,
                  marginBottom: 5,
                  marginLeft: 10,
                }}
              >
              Customer Payments List
              </Typography>




        <Box sx={{mt:2}}>
              <Grid container spacing={{ xs: 1, sm: 2, md: 2 }}>
                <Grid item size={{xs:12,sm:3}} >
                  <Paper
                    elevation={1}
                    sx={{
                      height: 110,
                      backgroundColor: "#008ffb",
                      width: "100%",
                      borderRadius: 2,
                    }}
                  >
                    <Box sx={{ padding: 1.5 }}>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: "550",
                          fontFamily: "sans-serif",
                          color: "#fff",
                        }}
                      >
                        TOTAL TRANSACTIONS
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 19,
                          fontWeight: "550",
                          fontFamily: "sans-serif",
                          color: "#fff",
                          mt: 1,
                        }}
                      >
                        {this.state.payment_count}
                      </Typography>

                      <Box
                        sx={{
                          width: "100%",
                          height: 45,
                          display: "flex",
                          justifyContent: "right",
                        }}
                      >
                        <Box
                          sx={{
                            height: 40,
                            width: 40,
                            backgroundColor: "#e2f1ff",
                            borderRadius: 3,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <AccountCircleIcon
                            sx={{ height: 30, width: 30, color: "#008ffb" }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                </Grid>

                <Grid item size={{xs:12,sm:3}}>
                  <Paper
                    elevation={1}
                    sx={{
                      height: 110,
                      backgroundColor: "#008ffb",
                      width: "100%",
                      borderRadius: 2,
                    }}
                  >
                    <Box sx={{ padding: 1.5 }}>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: "550",
                          fontFamily: "sans-serif",
                          color: "#fff",
                        }}
                      >
                       TOTAL AMOUNT (₹)
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 19,
                          fontWeight: "550",
                          fontFamily: "sans-serif",
                          color: "#fff",
                          mt: 1,
                        }}
                      >
                       {this.state.total_amount}₹
                      </Typography>
                      <Box
                        sx={{
                          width: "100%",
                          height: 45,
                          display: "flex",
                          justifyContent: "right",
                        }}
                      >
                        <Box
                          sx={{
                            height: 40,
                            width: 40,
                            backgroundColor: "#e2f1ff",
                            borderRadius: 3,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <PaidIcon
                            sx={{ height: 30, width: 30, color: "#008ffb" }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                </Grid>

            
              </Grid>
</Box>



<Box>
 
<Paper elevation={0} sx={{ width: "100%", minHeight: 200, mt: 2 }}>
                 <Box sx={{ mt: 0, padding: 2 }}>
                  <TableContainer component={Box}>
                    <Table
                      sx={{ minWidth: 720 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="left"
                            sx={{
                              ml:10,
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#33abdf",
                               textTransform:'uppercase'
                            }}
                          >
                            sr. no
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#33abdf",
                               textTransform:'uppercase'
                            }}
                          >
                           Payment Gateway
                          </TableCell>
                           <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#33abdf",
                               textTransform:'uppercase'
                            }}
                          >
                           Merchant id
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#33abdf",
                               textTransform:'uppercase'
                            }}
                          >
                          Customer email
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#33abdf",
                               textTransform:'uppercase'
                            }}
                          >
                            Payment  Date
                          </TableCell>
                        
                          <TableCell
                            align="right"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#33abdf",
                               textTransform:'uppercase'
                            }}
                          >
                          Transaction id
                          </TableCell>

                          <TableCell
                            align="right"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#33abdf",
                               textTransform:'uppercase'
                            }}
                          >
                        Amount(₹)
                          </TableCell>

                          <TableCell
                            align="right"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#33abdf",
                              display:'flex',
                              textTransform:'uppercase'
                            }}
                          >
                          Status
                          </TableCell>
                       
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.paymentList.map((row,index) => (
                          <TableRow
                            key={row._id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 } , backgroundColor : index % 2?'#f8f8f8':'#fff'
                            }}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{ color: "#42526e", fontSize: 13 }}
                            >
                                {index + 1}
                            </TableCell>
                        
                            <TableCell align="left" sx={{ color: "#42526e",fontSize:12,fontWeight:'600' }}>
                              Razor pay payments
                            </TableCell>  

                              <TableCell align="left" sx={{ color: "#42526e",fontSize:12,fontWeight:'600' }}>
                              {row.seller_id==""?"---":row.seller_id}
                            </TableCell>  

                            <TableCell align="left" sx={{ color: "#42526e",fontSize:12,fontWeight:'600' }}>
                            {row.customer_email==""?"---":row.customer_email}
                            </TableCell>  
                            
                          <TableCell align="right" sx={{ color: "#42526e",fontSize:12 }}>
                           {moment(row.transaction).format('YYYY-MM-DD hh:mm')}
                            </TableCell>
                            <TableCell align="right" sx={{ color: "#42526e" ,fontSize:12}}>
                            {row.response_data?.razorpay_payment_id}
                            </TableCell>
                            <TableCell align="center" sx={{ color: "#42526e" ,fontSize:12}}>
                             ₹ {row.amount}
                            </TableCell>
                            <TableCell align="right" sx={{ color: "#42526e" ,fontSize:12}}>
                            <Button size="small" variant="contained" color="success" sx={{fontSize:8,ml:2}}>Success</Button> 
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Divider />
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={this.state.payment_count}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                  />
                </Box>
              </Paper>

</Box>





















            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              position: "fixed",
              top: 0,
              left: { xs: 0, sm: 235 },
            }}
          >
            <Appheaderc />
          </Box>

        </Box>
      </div>
    );
  }
}

export default Payments;
